const getVintages = () => {
  const currentYear = new Date().getFullYear();
  const yearArray = Array.from({ length: currentYear - 1899 }, (_, index) => currentYear - index);
  const options = yearArray.map((year) => ({ label: `${year}`, value: year }));

  // Add NV (Non-Vintage) option at the top
  options.unshift({ label: 'NV', value: 9999 });

  return options;
};

export default getVintages;